import React from "react"

const Button = ({ children, className = "", to }) => (
  <button className={`button ${className}`}>
    {to ? <a href={to}>{children}</a> : children}
  </button>
)

const ButtonPurple = ({ children, to }) => (
  <Button to={to} className="button--filled button--purple">
    {children}
  </Button>
)

export default Button

export { ButtonPurple }
